<!--数据卡片-->
<template>
  <div class="score-card">
    <div v-if="type == 1" class="tit">考核分</div>
    <div v-if="type == 2" class="title">
      <span>考核排名</span><img class="icon" src="../../../assets/image/t-right.png" />
    </div>
    <div v-if="type == 1" class="cnt">{{ data.num }}<span class="txt">分</span></div>
    <div v-else-if="type == 2" class="cnt ranking"><span class="score-card-up num">{{ data.ranking }}</span><span
        class="txt">名</span></div>
    <div class="diff" v-if="type == 2">
      <span class="diff-tit">较上季度</span>
      <span v-if="Number(data.rankingChange) > 0" class="score-card-up">{{ data.rankingChange }}&#160;↑</span>
      <span v-if="Number(data.rankingChange) < 0" class="score-card-down">{{ data.rankingChange }}&#160;↓</span>
      <span v-if="Number(data.rankingChange) == 0">&#160;0</span>
      <span v-if="data.rankingChange == '-'">&#160;-</span>
    </div>
    <div v-if="type == 1" class="diff">
      <!-- <span class="diff-tit">较上季度</span>
      <span v-if="Number(data.diff) > 0" class="score-card-up">{{ data.diff }}&#160;↑</span>
      <span v-if="Number(data.diff) < 0" class="score-card-down">{{ data.diff }}&#160;↓</span>
      <span v-if="Number(data.diff) == 0">&#160;0</span>
      <span v-if="data.diff == '-'">&#160;-</span> -->
      <span class="diff-tit">考核排名 第 {{ data.ranking }} 名</span>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    // 样式类型
    type: {
      type: Number,
      default: 0
    },
    // 数据
    data: {
      type: Object,
      default: () => {
        return {
          title: '',
          num: '',
          diff: '',
          title2: '',
          ranking: '',
          rankingChange: ''
        }
      }
    }

  },
  data() {
    return {
      isUp: false,
      isFall: false
    }
  },
  computed: {

  },
  methods: {

  },
  created() {
    if (Number(this.data.diff) > 0) {
      console.log(Number(this.data.diff))
      this.isUp = true
      this.isFall = false
    } else if (Number(this.data.diff) < 0) {
      this.isUp = false
      this.isFall = true
    }
  },
  mounted() {

  }

}
</script>

<style scoped lang="less">
.score-card {
  width: 176px;
  padding: 16px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .title {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 12px;

    .icon {
      width: 12px;
      height: 12px;
      margin-left: 4px;
    }
  }

  &-up {
    // display: flex;
    color: rgba(54, 179, 116, 1);
    margin-left: 4px;
    font-size: 12px;
    vertical-align: top;
    display: inline-block;
    text-align: center;
    position: relative;

    .txt {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(54, 179, 116, 1);
      line-height: 10px;
      margin-left: 4px;
      position: absolute;
      float: left;
      display: inline-block;
      font-weight: normal;
      bottom: 4px;
    }

    .r-img {
      width: 8px;
      height: 12px;
    }
  }

  &-down {
    display: flex;
    color: #FF4D4D;
    margin-left: 4px;

    .r-img {
      width: 8px;
      height: 12px;
    }
  }

  &-fair {
    color: #2283E6;
  }

  .tit {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 12px;
  }

  .cnt {
    margin-top: 8px;
    margin-bottom: 9px;
    font-size: 32px;
    font-family: DIN-Bold, DIN;
    font-weight: bold;
    line-height: 32px;
    color: rgba(54, 179, 116, 1);
    vertical-align: top;
    display: inline-block;
    text-align: center;
    position: relative;

    .txt {
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(54, 179, 116, 1);
      line-height: 10px;
      margin-left: 4px;
      position: absolute;
      float: left;
      display: inline-block;
      font-weight: normal;
      bottom: 4px;
    }

  }

  .ranking {
    display: inline-block;
    align-items: baseline;
    position: relative;

    .txt {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(54, 179, 116, 1);
      line-height: 12px;
      position: absolute;
      float: left;
      display: inline-block;
      font-weight: normal;
      bottom: 4px;
    }

    .num {
      font-size: 32px;
      font-family: DIN-Bold, DIN;
      font-weight: bold;
      color: rgba(54, 179, 116, 1);
      line-height: 32px;
      margin-left: 3px;
      margin-right: 3px;
    }
  }

  .diff {
    display: flex;
    align-items: center;
    flex-direction: row;

    &-tit {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 12px;
    }
  }
}
</style>
